<script>
    import Svgo from "./svgo.svelte";
</script>

<Svgo {...$$props} on:click>
    <circle
            cx="12"
            cy="12.0002"
            r="10.05"
            stroke="currentColor"
            stroke-width="1.5"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2453 6.4834C13.2735 6.4834 14.1119 6.75232 14.7447 7.3218C15.3774 7.87546 15.6938 8.63477 15.6938 9.59972C15.6938 10.3907 15.4881 11.0392 15.1085 11.5455C14.9661 11.7036 14.5074 12.1308 13.7481 12.7951C13.4633 13.0324 13.2577 13.3013 13.1153 13.5861C12.9571 13.9025 12.878 14.2347 12.878 14.6143V14.8358H11.0589V14.6143C11.0589 14.0132 11.1538 13.4912 11.3752 13.0641C11.5809 12.637 12.1978 11.9726 13.226 11.0551L13.4159 10.8336C13.7006 10.4856 13.843 10.1059 13.843 9.71046C13.843 9.18843 13.6848 8.77714 13.4001 8.47658C13.0995 8.17602 12.6724 8.03365 12.1345 8.03365C11.4385 8.03365 10.9481 8.2393 10.6476 8.68223C10.3786 9.04606 10.2521 9.56809 10.2521 10.2325H8.44873C8.44873 9.06188 8.78093 8.14438 9.47696 7.47999C10.1572 6.8156 11.0747 6.4834 12.2453 6.4834ZM11.9595 15.6105C12.3075 15.6105 12.608 15.7213 12.8453 15.9427C13.0668 16.1642 13.1933 16.4489 13.1933 16.797C13.1933 17.145 13.0668 17.4455 12.8295 17.667C12.5922 17.8885 12.3075 17.9992 11.9595 17.9992C11.6114 17.9992 11.3267 17.8727 11.0894 17.6512C10.8521 17.4297 10.7414 17.145 10.7414 16.797C10.7414 16.4489 10.8521 16.1642 11.0894 15.9427C11.3267 15.7213 11.6114 15.6105 11.9595 15.6105Z"
            fill="currentColor"
        />
</Svgo>